import { AfterViewInit, Component, ContentChildren, Input, QueryList, TemplateRef } from '@angular/core';
import { BulkActionToolbarComponent } from '@app/shared/components/bulk-actions/bulk-action-toolbar/bulk-action-toolbar.component';
import { TranscludeDirective } from '@app/shared/directives/transclude.directive';

@Component({
  selector: 'portal-bulk-action-toolbar-group',
  templateUrl: './bulk-action-toolbar-group.component.html',
  host: {},
  standalone: false,
})
export class BulkActionToolbarGroupComponent<T> implements AfterViewInit {
  @ContentChildren(TranscludeDirective)
  transclusions?: QueryList<TranscludeDirective>;

  @Input()
  label: string;

  labelTemplate?: TemplateRef<any>;

  get entries(): T[] {
    return this.toolbar.entries;
  }

  constructor(private toolbar: BulkActionToolbarComponent<T>) {}

  ngAfterViewInit(): void {
    this.labelTemplate = this.transclusions.find((item) => item.id === 'label')?.templateRef;
  }
}
